import { render, staticRenderFns } from "./editCollection.vue?vue&type=template&id=ef0bd4f2&scoped=true"
import script from "./editCollection.vue?vue&type=script&lang=js"
export * from "./editCollection.vue?vue&type=script&lang=js"
import style0 from "./editCollection.vue?vue&type=style&index=0&id=ef0bd4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0bd4f2",
  null
  
)

export default component.exports